/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import { FaAngleRight } from '@react-icons/all-files/fa/FaAngleRight'
import SublinkGroup from './SublinkGroup'
import '../../sass/mainv3.scss'
import { isValidUrl } from '../Utilities/URLRenderer'

function NavLinkGroup({ linkGroups, handleWindowReload, topbar, theme }) {
  const {
    internal: { type }
  } = linkGroups
  const buttonColor = (title, top) => {
    const name = title.toLowerCase()
    if (name === 'my account' || name === 'login' || name === 'log in') {
      return 'top-bar-item navigation__item blue-button'
    }
    if (top) {
      return 'top-bar-item navigation__item redeem-link'
    }
    return 'navigation__item'
  }

  const linkColor = title => {
    const name = title.toLowerCase()
    if (name === 'redeem your mail offer') {
      return 'navigation__link text_link black-text'
    }
    if (name === 'my account' || name === 'login' || name === 'log in') {
      return 'navigation__link text_link white-text'
    }
    return 'navigation__link text_link'
  }

  const linkType = links => {
    if (links?.url?.startsWith('http') || links.title === 'login' || links.title === 'Log In') {
      return (
        <a
          className={linkColor(links.title)}
          href={links.url}
          data-event={links.title.toLowerCase()}
          onClick={() =>
            topbar && !theme.isLoggedIn ? null : handleWindowReload(`${linkGroups.url}`)
          }
        >
          {links.title.toUpperCase()}
        </a>
      )
    }

    return (
      <Link
        className={linkColor(linkGroups.title)}
        to={linkGroups?.url}
        data-event={linkGroups.title.toLowerCase()}
        target={linkGroups.title.toLowerCase()}
        onClick={() =>
          topbar && !theme.isLoggedIn ? null : handleWindowReload(`${linkGroups.url}`)
        }
      >
        {linkGroups.title.toUpperCase()}
      </Link>
    )
  }

  return (
    <>
      <li className={buttonColor(linkGroups.title, topbar)}>
        {linkGroups.internal.type === 'ContentfulAvantComFooterNavList' ? (
          <>
            <p className={linkColor(linkGroups.title)} tabIndex="0">
              {isValidUrl ? (
                <a href={linkGroups?.url || '#'} className="menu-link">
                  {linkGroups.title.toUpperCase()}
                </a>
              ) : (
                <Link
                  to={linkGroups?.url || '#'}
                  className="menu-link"
                  onClick={() => handleWindowReload(`${linkGroups?.url}`)}
                >
                  {linkGroups.title.toUpperCase()}
                </Link>
              )}
              {!topbar ? <FaAngleRight className="show-mobile" /> : ''}
            </p>
            <SublinkGroup
              parentComponent={type}
              handleWindowReload={handleWindowReload}
              subLinks={linkGroups.links}
              topbar={topbar}
            />
          </>
        ) : (
          linkType(linkGroups)
        )}
      </li>
      {}
    </>
  )
}
NavLinkGroup.defaultProps = {
  handleWindowReload: () => {},
  topbar: false,
  theme: {}
}

NavLinkGroup.propTypes = {
  linkGroups: PropTypes.object.isRequired,
  handleWindowReload: PropTypes.func,
  topbar: PropTypes.bool,
  theme: PropTypes.object
}

export default NavLinkGroup
